import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";


export default function Search() {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggleDrawer = (open) => () => {
    setIsOpen(open);
  };

  return (
    <div>
      {/* Trigger Button (You can place this anywhere) */}
      <IconButton onClick={toggleDrawer(true)}>
        <SearchIcon fontSize="large" />{" "}
        {/* Replace with Search icon if needed */}
      </IconButton>

      {/* Top Drawer */}
      <Drawer
        anchor="top"
        open={isOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            height: "200px", // Customize height
            padding: 2,
            backgroundColor: "#333752",
            color: "white",
          },
        }}
      >
        <Box
          role="presentation"
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            height: "100%",
          }}
        >
          <div className="flex justify-between items-center ">
            <h2 className="text-xl font-semibold text-white">Search</h2>
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon className="text-white hover:bg-blue-950 rounded-full p-1" fontSize="large" />
            </IconButton>
          </div>

          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search here..."
          />
        </Box>
      </Drawer>
    </div>
  );
}
